import "apps/pathways/styles/components/result.scss";
import React from 'react';
import { resolve } from 'library/helpers/path-resolver';
import { Router, withRouter } from 'library/util/core-router';
import ResultModal from 'apps/pathways/components/result-modal';
import ReactDOM from 'react-dom';
import Pathway from 'apps/pathways/services/pathway';
import withPathway from 'apps/pathways/util/hoc/with-pathway';
import Feedback from 'apps/pathways/components/feedback';
import withConfig from 'util/hoc/with-config';

class Result extends React.Component {

    closeModal = () => {
      if (this.modal) {
        this.modal.classList.remove('active');
        const mount = document.getElementById('mount');
        mount.classList.remove('blur');

        const bodyScroll = document.body.scrollTop;

        document.body.style.overflow = '';
        document.body.scrollTop = 0;
        document.body.scrollTop = bodyScroll;

        setTimeout(() => {
          ReactDOM.unmountComponentAtNode(this.modal);
          this.modal.parentElement.removeChild(this.modal);
          this.modal = null;
        }, 250);
      }
    }

    openModal = () => {
      if (!this.modal) {
        this.modal = document.createElement('div');
        this.modal.classList.add('result-modal');
        document.body.appendChild(this.modal);

        const mount = document.getElementById('mount');
        mount.classList.add('blur');

        const bodyScroll = document.body.scrollTop;
        document.body.style.overflow = 'hidden';
        document.body.scrollTop = bodyScroll;
      }

      ReactDOM.render(
        <Router history={this.props.history}>
          <ResultModal
            start={this.start}
            close={this.closeModal}
            result={this.props.result}
            withPathway={resolve(this.props, 'configuration/apps/pathways/configuration/pathway', true)}
          />
        </Router>
        , this.modal, () => {
          setTimeout(() => {
            if (this.modal) {
              this.modal.classList.add('active');
            }
          }, 250);
        });
    }

    start = async () => {
      this.props.newPathway(this.props.result);
      this.props.history.push('/pathways');
    }

    componentWillUnmount() {
      if (this.modal) {
        this.closeModal();
      }
    }

    get industry() {
      return ((((this.props.result || {}).industries||[]).shift()||{}).title||'').toUpperCase() || 'CAREER';
    }

    render() {
      const { result } = this.props;
      return (
        <div onClick={this.openModal} className="result">
          <div className="result-title">
            <span>{ result.title }</span>
          </div>
          { this.props.children }
          <div className="result-spacer" style={{maxHeight:'1em'}} />
          <p className="result-body">
            { result.description }
          </p>
          <div className="result-spacer" />
          <Feedback hide refreshOnDislike={false} id={result.id} />
          <div className="result-footer">
            <div title={this.industry}>{this.industry}</div>
            <div className="result-footer-link" onClick={this.openModal}>more info</div>
          </div>
        </div>
      );
    }
}

export default withPathway(withRouter(withConfig(Result)));
